import React, { useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from '../../AppContext';

const useStyles = makeStyles(() => ({
  viz: {
    height: 300,
    width: '100%',
    '& > div': {
      backgroundColor: 'transparent',
    },
  },
}));

const Donut = ({ measure }) => {
  const elementRef = useRef();
  const vizRef = useRef();

  const { nebula } = useContext(AppContext);

  useEffect(async () => {
    if (!nebula) return;

    vizRef.current = await nebula.render({
      element: elementRef.current,
      type: 'donut2022',
      fields: [
        {
          // outlet
          qDef: {
            qFieldDefs: ['Gender - 2022'],
            qSortCriterias: [
              {
                qSortByExpression: -1,
                qExpression: {
                  qv: `Sum({<[Job Role - 2022]={"${measure}"}, [Results - 2022]={"Disaggregate"}, [Race - 2022]=>} [Number of Employees - 2022]) / Sum(Total {<[Job Role - 2022]={"${measure}"}, [Results - 2022]={"Disaggregate"}, [Race - 2022]=>} [Number of Employees - 2022])`,
                },
              },
            ],
            autoSort: false,
          },
        },
        {
          qDef: {
            // remove unknown ??
            qDef: `Sum({<[Job Role - 2022]={"${measure}"}, [Results - 2022]={"Disaggregate"}, [Race - 2022]=>} [Number of Employees - 2022]) / Sum(Total {<[Job Role - 2022]={"${measure}"}, [Results - 2022]={"Disaggregate"}, [Race - 2022]=>} [Number of Employees - 2022])`,
          },
        },
      ],
    });
  }, [nebula]);

  const classes = useStyles();
  return (
    <>
      <div id="donutViz" className={classes.viz} ref={elementRef} />
    </>
  );
};

Donut.propTypes = {
  measure: PropTypes.string,
};

Donut.defaultProps = {
  measure: '',
};

export default Donut;
